import { FairFareQueryParams, getFairFareQueryParams } from 'types/interfaces/shared';
import { getBaseURL, getClient } from '../BLL/clients/HttpClient';
import { ApiEndPoint } from '../BLL/Enums/ApiEndPoint';
import { 
  PaymentRequestsResponse, 
  PaymentRequest, 
  UpdatePaymentRequestData,
  UpdatePaymentRequestResponse
} from '../pages/Finance/types/finance.types';

export const getAllPaymentRequests = async (
  query: FairFareQueryParams = {},
  carrierId?: number
): Promise<PaymentRequestsResponse> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  // Build query params similar to claims service
  const params = getFairFareQueryParams(query);

  if (carrierId) {
    (params as any).carrierId = carrierId;
  }

  const { data } = await client.get<PaymentRequestsResponse>('v1/payment-requests', {
    params,
  });

  return data;
};

export const getPaymentRequestById = async (
  paymentRequestId: string
): Promise<PaymentRequest> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const { data } = await client.get<PaymentRequest>(`v1/payment-requests/${paymentRequestId}`);

  return data;
};

export const updatePaymentRequest = async (
  paymentRequestId: string,
  updateData: UpdatePaymentRequestData
): Promise<UpdatePaymentRequestResponse> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const { data } = await client.put<UpdatePaymentRequestResponse>(
    `v1/payment-requests/${paymentRequestId}`,
    updateData,
    { validateStatus: (status) => status < 400 }
  );

  return data;
};

export const removeBillFromPaymentRequest = async (
  paymentRequestId: string,
  billId: string
): Promise<UpdatePaymentRequestResponse> => {
  // First get the current payment request to get all current bills
  const currentPaymentRequest = await getPaymentRequestById(paymentRequestId);
  
  // Filter out the bill to be removed
  const remainingBills = currentPaymentRequest.bills
    ?.filter(bill => bill.billId !== billId)
    .map(bill => bill.billId) || [];

  // Update with remaining bills
  return updatePaymentRequest(paymentRequestId, { bills: remainingBills });
};

export const markPaymentAsPaid = async (
  paymentRequestId: string
): Promise<any> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });
  const { data } = await client.post(`v1/payment-requests/${paymentRequestId}/pay`);
  return data;
};

export const undoPaymentAsPaid = async (
  paymentRequestId: string
): Promise<any> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });
  const { data } = await client.post(`v1/payment-requests/${paymentRequestId}/undo-pay`);
  return data;
};
